interface OzetKartProps {
  title: string;
  value: string;
  subtitle: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  trend?: { val: string; up: boolean } | null;
}

function OzetKart({ title, value, subtitle, icon, iconBg, iconColor, trend }: OzetKartProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">{title}</p>
          <p className="text-2xl font-bold text-gray-800 mt-1.5 truncate">{value}</p>
          <p className="text-xs text-gray-400 mt-1">{subtitle}</p>
        </div>
        <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${iconBg}`}>
          <i className={`${icon} text-xl ${iconColor}`}></i>
        </div>
      </div>
      {trend && (
        <div className={`flex items-center gap-1 mt-3 text-xs font-semibold ${trend.up ? 'text-emerald-600' : 'text-red-500'}`}>
          <i className={trend.up ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}></i>
          <span>{trend.val} geçen aya göre</span>
        </div>
      )}
    </div>
  );
}

interface Props {
  ozet: {
    toplamServis: number;
    buAyServis: number;
    buAyKazanc: number;
    gecenAyKazanc: number;
    toplamKazanc: number;
    ortalamaUcret: number;
    enCokIslem: string;
    enCokIslemSayi: number;
  };
}

export default function OzetKartlar({ ozet }: Props) {
  const kazancFark = ozet.gecenAyKazanc > 0
    ? Math.round(((ozet.buAyKazanc - ozet.gecenAyKazanc) / ozet.gecenAyKazanc) * 100)
    : null;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <OzetKart
        title="Bu Ay Servis"
        value={String(ozet.buAyServis)}
        subtitle={`Toplam ${ozet.toplamServis} servis`}
        icon="ri-tools-line"
        iconBg="bg-sky-100"
        iconColor="text-sky-600"
      />
      <OzetKart
        title="Bu Ay Kazanç"
        value={`₺${ozet.buAyKazanc.toLocaleString('tr-TR')}`}
        subtitle={`Geçen ay: ₺${ozet.gecenAyKazanc.toLocaleString('tr-TR')}`}
        icon="ri-money-dollar-circle-line"
        iconBg="bg-emerald-100"
        iconColor="text-emerald-600"
        trend={kazancFark !== null ? { val: `%${Math.abs(kazancFark)}`, up: kazancFark >= 0 } : null}
      />
      <OzetKart
        title="Ortalama Ücret"
        value={`₺${ozet.ortalamaUcret.toLocaleString('tr-TR')}`}
        subtitle="Tüm servisler ortalaması"
        icon="ri-bar-chart-line"
        iconBg="bg-orange-100"
        iconColor="text-orange-500"
      />
      <OzetKart
        title="En Çok Yapılan"
        value={ozet.enCokIslem}
        subtitle={`${ozet.enCokIslemSayi} servis`}
        icon="ri-award-line"
        iconBg="bg-violet-100"
        iconColor="text-violet-600"
      />
    </div>
  );
}
